import React from 'react';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { NAComponent } from 'pages/TireInventory/TireInventoryItems/FleetTireInventory';
import CustomTable from 'components/custom/CustomTableTemp';
import { formatDate } from 'pages/TireInventory/TireInventory';
import CommonGridItem from '../CommonGridItem';
import Loading from 'components/Loading';
import LoadAnimation from 'components/LoadAnimation';
import { setAccessTokenSelector } from 'redux/users/ducks';

import {
  currentNewsLetterKpi,
  newsLetterOverview,
} from 'services/fleet_service';
import { decodeSource } from 'pages/Home/event_const';
import i18next from 'i18next';
import { Alert } from '@mui/material';

const NewsLetter = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const access_token = useSelector(setAccessTokenSelector);
  const [newsletterData, setNewLetterOverview] = useState(null);
  const [tabs, setTabs] = useState(null);
  const [currentTabkey, setCurrentTabKey] = useState(null);
  const [data, setData] = useState(null);
  const [_columns, setColumns] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [pageNo, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [interval, setInterval] = useState('weekly');
  const [total, setTotal] = useState(0);
  const [flag, setFlag] = useState(false);
  const currentLanguage = i18next.language;
  useEffect(() => {
    async function fetchNewsLetterOverview() {
      try {
        let params = {
          interval: interval,
        };
        const res = await newsLetterOverview(params);
        if (res?.status === 200) {
          let obj = res?.data?.resp;
          delete obj.customer_id;
          setNewLetterOverview(obj);
          let arr = Object.keys(obj);
          let temp = [];
          for (let i = 0; i < arr.length; i++) {
            let key = arr[i];
            temp.push({
              label: t(`newsletter.${key}`),
              component: <></>,
              id: key,
              category: key,
            });
          }

          setTabs(temp);
          setFlag(false);
          if (currentTab === 0) {
            // setCurrentTab(0);
            setCurrentTabKey(arr[0]);
          }
        } else if (res?.status === 400) {
          setFlag(true);
        }
      } catch (err) {
        console.error(err);
      }
    }
    if (access_token) {
      fetchNewsLetterOverview();
    }
    // eslint-disable-next-line
  }, [access_token, currentLanguage, interval]);

  useEffect(() => {
    async function fetchCurrentKpi() {
      try {
        setIsLoading(true);
        const params = {
          kpi: currentTabkey,
          page_no: pageNo,
          per_page: rowsPerPage,
          interval: interval,
        };
        const res = await currentNewsLetterKpi(params);
        if (res?.data?.resp?.data?.length) {
          let arr = res?.data?.resp?.data;
          let cols = [];
          let temp = arr[0];
          let keys = Object.keys(temp);

          for (let i = 0; i < keys.length; i++) {
            let str;
            if (keys[i] === 'entity_id') {
              if (
                ['tires_mounted', 'tires_unmounted', 'tires_created'].includes(
                  currentTabkey
                )
              ) {
                str = t('tireInventoryItems.titles.tire_id');
              } else {
                str = t('common.vehicle') + 'Id';
              }
            } else {
              str = capitalizeFirstLetter(keys[i]);
            }
            cols.push({
              key: keys[i],
              title: str,
              render: row => (
                <NAComponent val={calculateValue(keys[i], row[keys[i]])} />
              ),
              dataHook: keys[i],
            });
          }
          setTotal(res?.data?.resp?.total);
          setColumns(cols);
          setData(arr);
        } else {
          setColumns([]);
          setData([]);
          setTotal(0);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    }
    if (currentTabkey) {
      fetchCurrentKpi();
    }
    // eslint-disable-next-line
  }, [currentTabkey, pageNo, rowsPerPage, interval]);

  const [currentTab, setCurrentTab] = useState(0);

  const handleChange = (event, newValue) => {
    if (newsletterData) {
      let arr = Object.keys(newsletterData);
      setCurrentTab(newValue);
      setCurrentTabKey(arr[newValue]);
      setPage(0);
      setRowsPerPage(10);
    }
  };

  if (isLoading) {
    return <Loading />;
  }
  if (flag) {
    return <Alert severity='error'>{t('common.newsletter_error')}</Alert>;
  }

  return (
    <div style={{ maxHeight: '74vh' }}>
      {isDownloading && (
        <LoadAnimation
          loading={isDownloading}
          setLoading={setIsDownloading}
          useMultiple={true}
        />
      )}
      {tabs && (
        <CommonGridItem
          title={t('common.newsletter')}
          currentTab={currentTab}
          tabs={tabs}
          handleChange={handleChange}
          overview={newsletterData}
          identifier='newsletter'
          setSearchQuery={() => {}}
          results={data}
          downloadResources={() => {}}
          interval={interval}
          setInterval={setInterval}
        />
      )}
      {_columns && data && currentTabkey && (
        <CustomTable
          data={data}
          columns={_columns}
          emptyMessage={t('common.noDataAvailable')}
          paginationHandler={(page, location) => setPage(page)}
          freq={total}
          loading={isLoading}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          isInitialRun={() => {}}
          total={total}
          revealedColumns={_columns.map(x => x.key)}
          currentPage={pageNo}
        />
      )}
    </div>
  );
};

export default NewsLetter;

function calculateValue(key, val) {
  if (key === 'createdAt') {
    return formatDate(val);
  }
  if (key === 'source_platform') {
    return decodeSource[val];
  }
  return val;
}
function capitalizeFirstLetter(val) {
  return val
    .split('_')
    .map(x => String(x).charAt(0).toUpperCase() + String(x).slice(1))
    .join(' ');
}
